export const ADMIN_BASE = '/admin';

/** Whether the page is under the console, for code that runs outside React. */
export function isAdminPath(
  pathname: string = window.location.pathname,
): boolean {
  return pathname === ADMIN_BASE || pathname.startsWith(`${ADMIN_BASE}/`);
}
